import { Checkbox, IconButton, Icons, Tooltip } from '@healthinal/ui';
import { AddressContactDto } from '../../../../../api/generated/model/addressContactDto';
import { TruncateText } from '../../../../../components/TruncateText';
import { getSalutationName } from '../../../../../utils/salutation.ts';

type Props = {
  contact: AddressContactDto;
  onToggleActive?: (contact: AddressContactDto) => void;
  onShowHistory?: (contact: AddressContactDto) => void;
  isPending?: boolean;
};

export function ContactPersonTableRow({ contact, onToggleActive, onShowHistory, isPending }: Props) {
  return (
    <>
      <td>
        <TruncateText>{getSalutationName(contact.salutation)}</TruncateText>
      </td>
      <td>
        <TruncateText>{contact.lastName ?? '-'}</TruncateText>
      </td>
      <td>
        <TruncateText>{contact.firstName ?? '-'}</TruncateText>
      </td>
      <td>
        <TruncateText>{contact.function ?? '-'}</TruncateText>
      </td>
      <td>
        <TruncateText>{contact.phone ?? '-'}</TruncateText>
      </td>
      <td>
        <TruncateText>{contact.email ?? '-'}</TruncateText>
      </td>
      <td>
        <TruncateText>{contact.address?.organization ?? '-'}</TruncateText>
      </td>
      <td onClick={(e) => e.stopPropagation()} style={{ textAlign: 'center' }}>
        <Checkbox checked={!!contact.isActive} disabled={isPending} onClick={() => onToggleActive?.(contact)} />
      </td>
      <td onClick={(e) => e.stopPropagation()} style={{ textAlign: 'center' }}>
        <Tooltip title="Verlauf">
          <IconButton
            size="sm"
            variant="plain"
            color="neutral"
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onShowHistory?.(contact);
            }}>
            <Icons.History />
          </IconButton>
        </Tooltip>
      </td>
    </>
  );
}
